import { FilteredCreditApplication, Merchant } from '@applyonline/shared'
import { EProvince, EWorksheetStatus } from '@if/core/types'

export const canAccessWorksheet = (creditApp: FilteredCreditApplication, merchant: Merchant): boolean => {
  return (
    merchant.noPaymentPolicy &&
    creditApp.allIncomesConfirmed &&
    creditApp.worksheet?.status === EWorksheetStatus.Draft &&
    creditApp.allTaskCompletedForCVT
  )
}

export const getWorksheet = (creditApp: FilteredCreditApplication) => {
  if (creditApp.worksheet === null) {
    throw new Error('Worksheet is null')
  }
  return creditApp.worksheet
}

export const provinceSupportsInsurance = (
  stateIso: EProvince | null | undefined,
  includeAllProvinces: boolean,
): boolean => {
  if (includeAllProvinces) return true
  return stateIso !== EProvince.Quebec && stateIso !== EProvince.Saskatchewan
}
